import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={22}
      fill="none"
      viewBox="0 0 24 22"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 9h4c.266 0 .52-.105.707-.293L12 3.414v15.172l-5.293-5.293A1 1 0 0 0 6 13H2zm11.383 12.924A1 1 0 0 0 14 21V1a1 1 0 0 0-1.707-.707L5.586 7H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4.586l6.707 6.707a1 1 0 0 0 1.09.217m7.805-4.23A9.27 9.27 0 0 0 24 11.019a9.26 9.26 0 0 0-2.864-6.726 1 1 0 0 0-1.413.026 1 1 0 0 0 .026 1.413A7.29 7.29 0 0 1 22 11.018c0 1.997-.79 3.865-2.223 5.26-.027.028-.041.065-.065.096a.99.99 0 0 0 .042 1.323 1 1 0 0 0 1.414.02l.019-.021zM20 11.019c0 1.576-.721 3.049-1.977 4.044a.999.999 0 1 1-1.242-1.568A3.15 3.15 0 0 0 18 11.018c0-.994-.465-1.914-1.274-2.525a.999.999 0 1 1 1.205-1.596A5.13 5.13 0 0 1 20 11.017"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
